/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSimpleUserCommand
 */
export interface CreateSimpleUserCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateSimpleUserCommand
     */
    familyname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSimpleUserCommand
     */
    middlename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSimpleUserCommand
     */
    forename?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSimpleUserCommand
     */
    username?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateSimpleUserCommand
     */
    orgName?: string | null;
}

export function CreateSimpleUserCommandFromJSON(json: any): CreateSimpleUserCommand {
    return CreateSimpleUserCommandFromJSONTyped(json, false);
}

export function CreateSimpleUserCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSimpleUserCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'familyname': !exists(json, 'familyname') ? undefined : json['familyname'],
        'middlename': !exists(json, 'middlename') ? undefined : json['middlename'],
        'forename': !exists(json, 'forename') ? undefined : json['forename'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'orgName': !exists(json, 'orgName') ? undefined : json['orgName'],
    };
}

export function CreateSimpleUserCommandToJSON(value?: CreateSimpleUserCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'familyname': value.familyname,
        'middlename': value.middlename,
        'forename': value.forename,
        'username': value.username,
        'orgName': value.orgName,
    };
}


